import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import FormikTextField from './FormikTextField';
import FormikSelect from './FormikSelect';

import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import Modal from 'react-bootstrap/Modal';
import FormikErrorMessage from './FormikErrorMessage';
import { createUseStyles } from 'react-jss';
import Text from './Text';
import clsx from 'clsx';
import Button from './Button';
import FormikCheckbox from './FormikCheckbox';
import { RootState } from '../config/store';
import { hideAuthModals, showLoginModal } from '../actions/ui';
import {
  continueProfile,
  getAllCities,
  getAllCountries,
  registerUser,
} from '../services/ApiService';
import { setUser, loginLocally, setUsersFollow } from '../actions/auth';
import { formatJoiError } from '../lib/utils';
import { Area, City, Country, RegistrationInfo } from '../types';

import { getUserFollower } from '../services/ProfileService';
import { objectWithOutNull } from '../services/helpers';

export interface ContinueRegisterModalProps {}



const ContinueRegisterModal: React.FC<ContinueRegisterModalProps> = () => {
  const dispatch = useDispatch();
  const [cities, setCities] = useState<City[]>([]);
  const [countries, setCountries] = useState<Country[]>([]);
  const [detailsUserInfo, setDetailsUserInfo] = useState<Object>({
    birthday: '',
    gender: '',
    city_id: null,
    terms: false,
    is_interested_creator: false,
    mobile_number:'',
  });
  const [background, setBackground] = useState<any | null>(null);
  const [file, setFile] = useState<any | null>(null);
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>('');


  const textInput = useRef<HTMLInputElement>(null);

  const show = useSelector<RootState, boolean>(
    (state) => state.ui.showContinueRegisterModal,
  );
  

  const userData = useSelector<RootState, any>((state) => state.ui.userData);
  const continueRegisterFromGuest = useSelector<RootState, boolean>(
    (state) => state.ui.showGuest,
  );
  const formSchema = Yup.object()
  .shape({
    birthday: Yup.date().required(),
    gender: Yup.string().required(),
    country_id:Yup.object().required(),
    password: continueRegisterFromGuest ? Yup.string().required().min(6,'At least six characters!') : Yup.string(),
    mobile_number: Yup.string().required("Mobile number is a required field!"),

  })
  .required();
  const onHide = useCallback(() => {}, [dispatch]);

  const canClose = useSelector<RootState, boolean>(
    (state) => state.ui.canClose,
  );

  const changeProfile =  ()  => {
    if (textInput.current != null) textInput.current?.click();
  }

  const changeImage =  (event: any)  => {
    console.log(event);
    var input = event.target;
    if (input.files && input.files[0]) {
      setFile(event.target.files[0]);
      setBackground(URL.createObjectURL(event.target.files[0]));
    }
  }
  const countryPayload = useSelector<RootState, Country[]>((state) => state.countries);

  useEffect(() => {
    (async () => {
      try {
        setCountries(countryPayload);
      } catch (e) {}
    })();
  }, [countryPayload]);

  const handleChangeCountry = useCallback((item) => {
    (async () => {
      let cities = await getAllCities('&country_id=' + item.value);
      
      setCities(cities);
    })();
  }, []);

  const handleSubmit = useCallback(
    (data: any, form: any) => {
      return (async () => {
        console.log(data);
        try {
          let mainData :  RegistrationInfo  = { ...data };
          mainData.country_id = data['country_id'].value;
          mainData.city_id = data['city_id'].value;
          mainData.gender = data['gender'].value;
          mainData.mobile_number=data.mobile_number;
          mainData.is_interested_creator = mainData.is_interested_creator ? 0 : 1;
          mainData.is_approved_policies = 1;
          mainData._method = 'PUT';
          mainData.name = userData.name;
          mainData.email = userData.email;
          
          var form_data = new FormData();

          objectWithOutNull(mainData);
          Object.entries(mainData).forEach(([key, value]) => {
            form_data.append(key, value);
        });
          if (file){
            form_data.append('photo', file);            
          }
          if(!continueRegisterFromGuest && userData.socialPhoto){
              form_data.append('social_photo', userData.socialPhoto);
          }

          const { user } = await continueProfile(form_data, userData.token);
          dispatch(setUser(user));
          loginLocally(userData.token);
          dispatch(hideAuthModals());

          const usersFollow = await getUserFollower();
          dispatch(setUsersFollow(usersFollow));
          dispatch(hideAuthModals());
          window.location.reload(false);
        }
          catch (e) {
          setHasError(true);
          setErrorMessage(e as string)
          const err = formatJoiError(e);
          form.setErrors(err);
        }
      })();
    },
    [dispatch, userData,file],
  );
  const classes = useStyles();
  return (
    <Modal
      dialogClassName={clsx(classes.modal, 'auth-modal')}
      centered
      show={show}
      onHide={onHide}
    >
      <Modal.Header className={classes.header}>
        <Modal.Title>
          <Text className="m-0" color="white">
            Register
          </Text>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4">
        {hasError ? (
          <Text className={clsx('my-2', classes.tomato)}>
            {errorMessage}
          </Text>
        ) : null}
        <>
          {continueRegisterFromGuest ? (
            <Text className={clsx('my-2', classes.tomato)}>
              You can only checkout as guest once, please register your account
              information to continue.
            </Text>
          ) : null}
          <input
            type="file"
            ref={textInput}
            onChange={(e) => changeImage(e)}
            className={classes.mediaFile}
            id="mediaFile"
          />
          <div
            className={classes.imageProfile}
            style={{
              backgroundImage: `url(${background ||
                userData.socialPhoto ||
                `img/add-image.png`})`,
            }}
            onClick={changeProfile}
          ></div>
          <Formik
            initialValues={{
              ...detailsUserInfo,
              is_interested_creator: false,
              terms: false,
              city_id:0,
            }}
            onSubmit={handleSubmit}
            validationSchema={formSchema}
            validateOnChange
          >
            {({ handleSubmit, values, isValid, isSubmitting }) => (
              <Form onSubmit={handleSubmit}>
                {continueRegisterFromGuest ? (
                  <>
                  <FormikErrorMessage name="password" />
                  <FormikTextField
                    className={classes.input}
                    name="password"
                    type="password"
                    placeholder="password"
                  />
                  </>
                ) : null}
                
                <FormikTextField
                  name="birthday"
                  type="date"
                  placeholder="Birthdate"
                  className={classes.input}
                />
                
                <FormikSelect
                  className={classes.input}
                  name="gender"
                  placeholder="Select Gender"
                  options={[
                    {
                      label: 'Male',
                      value: 'Male',
                    },
                    {
                      label: 'Female',
                      value: 'Female',
                    },
                  ]}
                />
                <FormikSelect
                  className={classes.input}
                  name="country_id"
                  change={handleChangeCountry}
                  options={countries.map((country) => ({
                    label: country.long_name,
                    value: country.id,
                  }))}
                  placeholder="Country"
                  // styles={{
                  //   control: (styles: any) => ({
                  //     ...styles,
                  //     backgroundColor: '#fff',
                  //     padding: '6px',
                  //     border: '2px solid #dadada',
                  //     borderRadius: 5,
                  //     width: '100%',
                  //   }),
                  // }}
                />
                <FormikSelect
                  placeholder="City"
                  className={classes.input}
                  name="city_id"
                  options={cities.length ? cities.map((city) => ({
                    label: city.name,
                    value: city.id,
                    areas: city.areas,
                  })) : [{label:"other",value:null}]}

                  // styles={{
                  //   control: (styles: any) => ({
                  //     ...styles,
                  //     backgroundColor: '#fff',
                  //     padding: '6px',
                  //     border: '2px solid #dadada',
                  //     borderRadius: 5,
                  //     width: '100%',
                  //   }),
                  // }}
                />
                 <FormikErrorMessage name="mobile_number" />
                  <FormikTextField
                  name="mobile_number"
                  type="text"
                  placeholder="Mobile number"
                  className={classes.input}
                />
                <div className={classes.termsBox}>
                  <FormikCheckbox
                    id="terms"
                    name="terms"
                    checked={values.terms}
                  />
                  <label htmlFor="terms">
                    <Text bold as="span">
                      I accept{' '}
                      <a
                        className={classes.paragraph}
                        href="https://twigbig.com/terms-and-conditions"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Terms
                      </a>{' '}
                      and{' '}
                      <a
                        className={classes.paragraph}
                        href="https://twigbig.com/privacy-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Privacy Policy
                      </a>
                    </Text>
                  </label>
                </div>

                <div className={classes.termsBox}>
                  <FormikCheckbox
                    id="is_interested_creator"
                    name="is_interested_creator"
                    checked={values.is_interested_creator}
                  />
                  <label htmlFor="is_interested_creator">
                    <Text bold as="span">
                      request to join creator program
                    </Text>
                  </label>
                </div>

                <Button
                  type="submit"
                  disabled={!isValid || !values.terms || isSubmitting|| !values.city_id}
                  block
                >
                  <Text className="m-0" uppercase color="white">
                    Continu Register
                  </Text>
                </Button>
              </Form>
            )}
          </Formik>
        </>
      </Modal.Body>
    </Modal>
  );
};

const useStyles = createUseStyles({
  modal: {
    width: '100%',
    maxWidth: '500px',
  },
  header: {
    borderRadius: '5px !important',
    backgroundColor: '#522583',
    borderBottomLeftRadius: '0 !important',
    borderBottomRightRadius: '0 !important',
  },
  input: {
    marginBottom: '1rem',
  },
  paragraph: {
    color: '#9D7CFA',
    '&:hover': {
      color: '#9D7CFA',
    },
    '&:visited': {
      color: '#9D7CFA !important',
      textDecoration: 'underline',
    },
  },
  termsBox: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: '0.5rem',
  },
  loginBtn: {
    color: '#9D7CFA',
    background: 'none',
    border: 'none',
  },
  imageProfile: {
    width: '80px',
    height: '80px',
    backgroundColor: 'white',
    margin: '0px auto',
    border: '3px dashed gray',
    marginBottom: '1rem',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  mediaFile: {
    display: 'none',
    position: 'absolute',
  },
  tomato: {
    color: 'tomato !important',
  },
  bakcDiv: {
    textAlign: 'center',
    width: 'fit-content',
    margin: '0px auto',
    textDecoration: 'underline',
  },
});

export default ContinueRegisterModal;
